import React from 'react';
import { UnidadeResponsavel } from 'volto-ministerio-publico-federal/components/UnidadeResponsavel';
import type { UnidadeResponsavelData } from 'volto-ministerio-publico-federal/components/UnidadeResponsavel/types';

export interface UnidadeResponsavelBlockContent {
  unidade_responsavel_info?: UnidadeResponsavelData | null;
  modified?: string;
}

export interface MpfUnidadeResponsavelBlockViewProps {
  /**
   * O conteúdo da PÁGINA, não do slot. Chega em `metadata` nos dois modos:
   * `RenderSlotFill` passa `metadata={content}` na renderização, e o
   * `BlocksForm` do editor de slot também (ver `EditSlot.jsx`). `properties`
   * diverge entre os dois — na edição são os dados do slot — por isso o
   * fallback vem depois e não antes.
   */
  metadata?: UnidadeResponsavelBlockContent | null;
  properties?: UnidadeResponsavelBlockContent | null;
  isEditMode?: boolean;
}

/**
 * Bloco de sidebar "Área responsável" (RF03/RF04).
 *
 * Não tem dado próprio: o bloco só marca ONDE, dentro da coluna lateral, o
 * card da unidade aparece. Quem responde pela página vem do conteúdo, já
 * resolvido pelo backend em `unidade_responsavel_info` — com a herança da
 * pasta superior aplicada e os contatos filtrados pelos flags de exibição.
 *
 * Por isso o bloco é independente dos outros três da sidebar (RF04) e, ao
 * mesmo tempo, não pode ser a única forma de exibir a unidade: quando o
 * editor não o coloca na lateral, o `ContentContainer` renderiza o card no
 * rodapé do conteúdo. A unidade nunca deixa de ser identificada — o bloco
 * decide o lugar, não a existência.
 */
export const MpfUnidadeResponsavelBlockView: React.FC<
  MpfUnidadeResponsavelBlockViewProps
> = ({ metadata, properties, isEditMode }) => {
  const content = metadata ?? properties ?? null;

  if (!content?.unidade_responsavel_info?.titulo) {
    // Na edição do slot, um bloco que não desenha nada parece bloco quebrado.
    // Na página pública, ausência de unidade é ausência de card (ver
    // `components/UnidadeResponsavel`), então aqui devolvemos `null`.
    return isEditMode ? (
      <div className="mpf-unidade-responsavel mpf-unidade-responsavel--placeholder">
        <p>
          Área responsável — o card usa a unidade cadastrada nesta página e
          aparece aqui na coluna lateral.
        </p>
      </div>
    ) : null;
  }

  return <UnidadeResponsavel content={content} variant="sidebar" />;
};

export default MpfUnidadeResponsavelBlockView;
